import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "buttonText", "icon"]

  connect() {
    // Close dropdown when clicking outside
    this.clickOutside = this.clickOutside.bind(this)
  }

  toggle() {
    if (this.menuTarget.classList.contains("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    this.menuTarget.classList.remove("hidden")
    if (this.hasButtonTextTarget) {
      this.buttonTextTarget.textContent = "Hide Invite Form"
    }
    if (this.hasIconTarget) {
      this.iconTarget.classList.add("rotate-180")
    }
    document.addEventListener("click", this.clickOutside)
  }

  close() {
    this.menuTarget.classList.add("hidden")
    if (this.hasButtonTextTarget) {
      this.buttonTextTarget.textContent = "Show Invite Form"
    }
    if (this.hasIconTarget) {
      this.iconTarget.classList.remove("rotate-180")
    }
    document.removeEventListener("click", this.clickOutside)
  }

  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  // Don't close dropdown when clicking form elements inside it
  handleSubmit(event) {
    // Allow forms to submit, then close dropdown
    setTimeout(() => {
      this.close()
    }, 100)
  }

  disconnect() {
    document.removeEventListener("click", this.clickOutside)
  }
}